import { debounce } from "../Helpers";
import { ValueElement } from "./Base";

export enum TextInputType {
  Text = "text",
  Number = "number",
  Password = "password",
  Email = "email",
  Checkbox = "checkbox",
  Hidden = "hidden"
}

export class TextInputElement extends ValueElement {
  private instance: HTMLInputElement;

  private onChangeClick = () => this.onChange();

  private onKeyupClick = debounce(() => this.onChange());

  constructor(name: string,
    value: string = "",
    type: TextInputType = TextInputType.Text,
    classes: string[] = [],
    attrs: { key: string, value: string }[] = []) {
    super(name);

    this.instance = document.createElement("input");
    this.instance.setAttribute("type", type);
    this.instance.setAttribute("name", name);
    this.instance.setAttribute("id", name);
    if (type === TextInputType.Checkbox) {
      this.instance.checked = String(value) === "true";
    } else {
      this.instance.value = value;
    }
    this.instance.classList.add(...classes);
    attrs.forEach((attr) => {
      this.instance.setAttribute(attr.key, attr.value);
    });

    this.instance.addEventListener("change", this.onChangeClick);
    this.instance.addEventListener("keyup", this.onKeyupClick);
  }

  get element(): HTMLElement {
    return this.instance;
  }

  get value(): any {
    return this.instance.value;
  }

  set value(val: any) {
    this.instance.value = val;
  }

  dispose(): void {
    this.instance.removeEventListener("change", this.onChangeClick);
    this.instance.removeEventListener("keyup", this.onKeyupClick);
  }

  disable(): void {
    this.instance.disabled = true;
  }
}
